exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr:hover td {\n  background-color: rgba(76, 122, 227, 0.12) !important;\n}\ntable .private-conflict-icon,\ntable .del-conflict-icon {\n  margin-right: 6px;\n}\ntable .private-conflict td {\n  background-color: #fff8f5;\n}\ntable .add td {\n  background-color: #fff8f5;\n}\ntable .del {\n  color: #484866eb;\n  cursor: not-allowed !important;\n}\ntable .del > td:not(.hide) {\n  background-color: #ffffff;\n  text-decoration: line-through !important;\n}\ntable .del > td:not(.hide) span {\n  text-decoration: line-through;\n}\ntable .del .text,\ntable .del textarea {\n  text-decoration: line-through;\n}\n", ""]);

// exports
